import { Flex, Text, Box } from '@chakra-ui/react';
import { faArrowLeft, faGear } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonIcon } from '@morressier/alembic';
import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import { fetchSubmissionContext } from 'src/api/queries';

const ManageJournal = () => {
  const { shortname, journalId = '' } = useParams();

  const { data: journal } = useQuery({
    queryKey: ['submission-context', journalId],
    queryFn: () => (journalId ? fetchSubmissionContext(journalId) : null),
    retry: 0
  });

  return (
    <Flex flexDirection="column" padding={16} gap={8}>
      <Flex alignItems="center" gap={4}>
        <Link to={`/app/workspace/${shortname}/manage/journals`}>
          <ButtonIcon
            ariaLabel="Back to workspace settings"
            icon={<FontAwesomeIcon icon={faArrowLeft} />}
          />
        </Link>
        <Text textStyle="headingTitle">{journal?.data.name}</Text>
        <Box marginStart="auto">
          <Link to={'edit'}>
            <Button iconLeft={<FontAwesomeIcon icon={faGear} />}>
              Configure this Journal
            </Button>
          </Link>
        </Box>
      </Flex>
      <Text>Some content</Text>
    </Flex>
  );
};

export default ManageJournal;
